import PropTypes from 'prop-types';
import * as H from 'react-router-dom';
import {
    ActionCreatorWithPayload,
    ActionCreatorWithoutPayload,
} from '@reduxjs/toolkit';

export type TMoveData = {
    fromIndex: number;
    toIndex: number;
};

export type TModalState = {
    background: H.Location;
};

export type TOrderData = {
    name: string;
    order: {
        number: number;
    };
    success: boolean;
    message?: string;
};

export type TIngredientType = {
    _id: string;
    id?: string;
    index?: number;
    name: string;
    type: string;
    proteins: number;
    fat: number;
    carbohydrates: number;
    calories: number;
    price: number;
    image: string;
    image_mobile: string;
    image_large: string;
    __v: number;
};

export type TUser = {
    name: string;
    password?: string;
    email: string;
};

export type TPatchUser = {
    name?: string;
    password?: string;
    email?: string;
};

export type TLogin = {
    email: string;
    password: string;
};

export type TError = {
    success: boolean;
    message?: string;
} & TUser;

export type TUserForm = {
    name: string;
    email: string;
    password: string;
};

export type TUserResponse = {
    success: boolean;
    user: TUser;
};

export type TRefreshData = {
    success: boolean;
    accessToken: string;
    refreshToken: string;
};

export type TRegisterResponse = TRefreshData & { user: TUser };

export type TPasswordResetResponse = {
    success: boolean;
    message: string;
};

export type TConstructorItem = TIngredientType & { id: string };

export const ingredientType = PropTypes.shape({
    _id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    proteins: PropTypes.number.isRequired,
    fat: PropTypes.number.isRequired,
    carbohydrates: PropTypes.number.isRequired,
    calories: PropTypes.number.isRequired,
    price: PropTypes.number.isRequired,
    image: PropTypes.string.isRequired,
    image_mobile: PropTypes.string.isRequired,
    image_large: PropTypes.string.isRequired,
    __v: PropTypes.number.isRequired,
});

export enum WebsocketStatus {
    CONNECTING = 'CONNECTING...',
    ONLINE = 'ONLINE',
    OFFLINE = 'OFFLINE',
}

export type TwsActionTypes = {
    wsConnect: ActionCreatorWithPayload<string>;
    wsDisconnect: ActionCreatorWithoutPayload;
    wsSendMessage?: ActionCreatorWithPayload<any>;
    wsConnecting: ActionCreatorWithoutPayload;
    onOpen: ActionCreatorWithoutPayload;
    onClose: ActionCreatorWithoutPayload;
    onError: ActionCreatorWithPayload<string>;
    onMessage: ActionCreatorWithPayload<any>;
};

export type TwsOrder = {
    ingredients: Array<string>;
    _id: string;
    status: keyof typeof OrderStatus;
    name: string;
    number: number;
    createdAt: string;
    updatedAt: string;
};

export type TwsData = {
    success: boolean;
    orders: Array<TwsOrder>;
    total: number;
    totalToday: number;
};

export enum OrderStatus {
    done = 'Выполнен',
    pending = 'Готовится',
    cancelled = 'Отменен',
    created = 'Создан',
}

export enum OrderStatusColor {
    done = 'cyan',
    pending = 'cyan',
    cancelled = 'red',
    created = 'white',
}
